import { combineReducers } from 'redux';
import { CARRIERS_REQUEST_RSAA } from '../../actions/types';

import { paginate } from './paginate';

export const pagination = combineReducers({
  carriers: paginate({ types: CARRIERS_REQUEST_RSAA }),
});
